module.exports = __webpack_public_path__ + "static/media/36-6.7e80d062.mp3";